import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
export var ProductMessageRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  overflow: hidden;\n  padding: 16px;\n\n  & > a {\n    box-shadow: ", ";\n    border-radius: ", ";\n    align-items: center;\n    padding: 8px 16px;\n\n    div > img {\n      max-height: 83px;\n    }\n  }\n"])), function (props) {
  return getPaletteColor('white')(props);
}, themeGet('boxShadows.4'), function (props) {
  return themeGet('radii.default')(props);
});